import React, { useEffect, useState, useContext } from 'react';
import { addOutline, removeOutline, trashOutline } from 'ionicons/icons';
import { IonCard, IonCardContent, IonItem, IonButton, IonIcon } from '@ionic/react';
import { StartFightContext } from '../StartFightContext';

import '../../../styles/fight/items/MenuItemCard.scss';

/**
 * Abstracted card that can be used for both maker and taker side
 */
// eslint-disable-next-line no-unused-vars
const MenuItemCard = ({ item, onAmountChange, isEditable, rematchItem }) => {
  const startFightCtx = useContext(StartFightContext);
  const [itemAmount, setItemAmount] = useState(item.amount ?? item.quantity ?? 0);

  // useEffect(() => {
  //   if (typeof onAmountChange === 'function') {
  //     onAmountChange(itemAmount);
  //   }
  // }, [itemAmount, onAmountChange]);

  useEffect(() => {
    setItemAmount(item.amount ?? 0);
  }, [item.amount]);

  useEffect(() => {
    if (rematchItem) {
      startFightCtx.dispatch({
        action: 'setItem',
        item: {
          id: rematchItem.id,
          name: rematchItem.name,
          price: rematchItem.price,
          amount: rematchItem.amount,
        },
      });
      return;
    }
    if (startFightCtx.items[item.name] !== itemAmount) {
      startFightCtx.dispatch({
        action: 'setItem',
        item: {
          id: item.id,
          name: item.name,
          price: item.price,
          amount: itemAmount,
        },
      });
    }
    // adding startFightCtx causes infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemAmount, item.id, item.name, item.price, rematchItem]);

  return (
    <IonCard className='menu-item-card'>
      <IonCardContent>
        <div className='item-card-wrapper'>
          <div className='item-card-info'>
            <p>{item.name}</p>
          </div>
        </div>
        <p className='price'>${item.formattedPrice || (item.price / 100).toFixed(2)}</p>
        <IonItem>
          <div className='quantity-control-container'>
            {itemAmount > 0 ? (
              <>
                <IonButton
                  fill='clear'
                  size='small'
                  className={`quantity-button ${isEditable && itemAmount > 0 ? '' : 'hidden'}`}
                  onClick={() => setItemAmount(old => Math.max(old - 1, 0))}>
                  <IonIcon icon={itemAmount === 1 ? trashOutline : removeOutline} slot='icon-only' />
                </IonButton>
                <p className='quantity-value'>{itemAmount}</p>
                <IonButton
                  fill='clear'
                  size='small'
                  className={`quantity-button ${isEditable ? '' : 'hidden'}`}
                  onClick={() => setItemAmount(old => Math.max(old + 1, 0))}>
                  <IonIcon icon={addOutline} slot='icon-only' />
                </IonButton>
              </>
            ) : (
              <IonButton fill='clear' size='small' className='quantity-button' onClick={() => setItemAmount(1)}>
                <IonIcon icon={addOutline} slot='icon-only' />
              </IonButton>
            )}
          </div>
        </IonItem>
      </IonCardContent>
    </IonCard>
  );
};

export default MenuItemCard;
